import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.195 11.805a.667.667 0 0 1 0-.943L11.057 8 8.195 5.138a.667.667 0 1 1 .943-.943l3.333 3.334c.26.26.26.682 0 .942l-3.333 3.334a.667.667 0 0 1-.943 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.529 11.805a.667.667 0 0 1 0-.943L6.39 8 3.53 5.138a.667.667 0 1 1 .942-.943L7.805 7.53c.26.26.26.682 0 .942L4.47 11.805a.667.667 0 0 1-.942 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })